export class SelectItem {
    constructor (
        public Value: any, 
        public Text: string
    ) {
        
    }
}